import Coordinator_Utilization_IMG from '@/assets/images/dashboard/Coordinator_Utilization.png';
import Daily_Cores_Usage_IMG from '@/assets/images/dashboard/Daily_Cores_Usage.png';
import Workloads_by_Duration_IMG from '@/assets/images/dashboard/Workloads_by_Duration.png';
import Agents_correlations_IMG from '@/assets/images/dashboard/Agents_correlations.png';
import { Getters } from '../getters/main-getters';
import { Actions } from '../actions/main-actions';
import { Mutations } from '../mutations/main-mutations';

const initialState = {
  pageSize: { width: null, height: null },
  license: {
    LicenseKey: 'GAGZ-V6BS-SNAK-RKIN',
    IsEnterprise: true,
    DaysLeft: 320,
    ProductFeatures: 222,
    AddonFeatures: 8184,
    TotalNamedInitiators: 0,
    TotalFloatingInitiators: 0,
    TotalFloatingCIInitiators: 0,
    AvailableNamedInitiators: 0,
    AvailableFloatingInitiators: 0,
    AvailableFloatingCIInitiators: 0,
    TotalFloatingCores: 1000,
    AvailableFloatingCores: 982,
    RegisteredAgentsCount: 3,
    WaitingAgentsCount: 0,
    StateInfo: {},
  },
  leftDrawer: {
    state: false,
    title: '',
    component: '',
  },
  menu: [
    {
      header: true,
      title: 'IncrediX Navigation',
      hiddenOnCollapse: true,
    },
    {
      href: '/dashboard',
      title: 'Dashboard',
      icon: 'fa fa-chart-area',
    },
    {
      href: '/settings',
      title: 'Settings',
      icon: 'fa fa-skull-crossbones',
      child: [
        {
          href: '/settings',
          title: 'Sub Link',
        },
      ],
    },
  ],
  dashboardLayout: {
    setup: [
      {
        draggable: true,
        title: 'Coordinator Utilization',
        image: Coordinator_Utilization_IMG,
        x: 0,
        y: 0,
        w: 0,
        h: 0,
        i: '0',
        c: 'coordinator-utilization-chart',
        s: 'coordinatorUtilizationChart',
        mw: 3,
        mh: 10,
        dataset: 'coordinatorUtilizationChart',
      },
      {
        draggable: true,
        title: 'Daily Cores Usage',
        image: Daily_Cores_Usage_IMG,
        x: 5,
        y: 0,
        w: 6,
        h: 10,
        i: '1',
        c: 'daily-cores-usage-chart',
        s: 'dailyCoresUsageChart',
        mh: 10,
        mw: 3,
        dataset: 'dailyCoresUsageChart',
      },
      // {
      //   draggable: true,
      //   title: 'Utilization',
      //   image: require('@/assets/images/dashboard/Utilization.png'),
      //   x: 0,
      //   y: 11,
      //   w: 6,
      //   h: 10,
      //   i: '2',
      //   c: 'workload-chart',
      //   s: 'workloadChart',
      //   mh: 10,
      //   mw: 4,
      //   dataset: 'workloadUtilizationDataset',
      // },
      {
        draggable: true,
        title: 'Workloads By Duration',
        image: Workloads_by_Duration_IMG,
        x: 5,
        y: 11,
        w: 6,
        h: 10,
        i: '3',
        c: 'workload-by-chart',
        s: 'workloadByChart',
        mh: 10,
        mw: 4,
        dataset: 'workloadsByDataset',
      },
      {
        draggable: true,
        title: 'Agents Utilization',
        image: Agents_correlations_IMG,
        x: 0,
        y: 21,
        w: 6,
        h: 10,
        i: '4',
        c: 'agents-utilization-chart',
        s: 'agentsUtilizationChart',
        mh: 10,
        mw: 4,
        dataset: 'agentsUtilizationChart',
      },
    ],
    layout: [
      {
        x: 1,
        y: 0,
        w: 12,
        h: 16,
        i: '9999',
        mh: 12,
        c: 'chart-placeholder',
        s: 'chartPlaceholder',
        dataset: '',
      },
    ],
  },
  dialog: {
    open: false,
    component: 'SuccessDialog',
    data: {},
    width: 400,
    height: 500,
    locked: false,
  },
  coordinatorLinkStatus: {
    isLinkUp: true,
    message: '',
    retries: 0,
  },
};

export default {
  namespaced: true, // set to true in case we wish to use multiple modules at the same time
  state: initialState,
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
};
